<template>
  <router-view />
  <NativeGate />
</template>

<script setup>
import NativeGate from './components/NativeGate.vue'
</script>

<style>
* { box-sizing: border-box; }
html, body, #app { height: 100%; margin: 0; padding: 0; }

/* font-family + base size + bg/text all driven by the tokens in main.css,
   so the tenant's chosen font + theme + density flow through automatically. */
body {
  font-family: var(--font-family, 'Cairo'), 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: var(--font-base-size, 14px);
  background: var(--color-bg);
  color: var(--color-text);
  transition: background-color 0.15s, color 0.15s;
}
</style>
